import {Component, OnDestroy, OnInit} from '@angular/core';
import { OauthService } from 'ng2-kalieki-acs';
import {SubscriptionsContainer} from '../shared/subscriptions-container';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit, OnDestroy {

  loggedIn: boolean;
  subs = new SubscriptionsContainer();


  constructor(private oauth: OauthService) {
    this.subs.add = this.oauth.onLoggedIn.subscribe(token => {
      this.loggedIn = true;

    });

    this.subs.add = this.oauth.onLoggedOut.subscribe(msg => {
      this.loggedIn = false;
    });
  }

  searchBy: String = 'orderNmuber';

  ngOnInit() {
  }

  ngOnDestroy(): void {
    console.log(' Nav Component - ngOnDestroy ' );
    this.subs.dispose();
  }


  signIn() {
    this.oauth.signOn();
  }

  signOut() {
    this.oauth.signOut();
    return false;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/nav/nav.component.ts